import React from "react";

import { WebPageURL, isoWebPageURL } from "../../models/nominals";

type LinkProps = React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
>;

interface IProps extends Omit<LinkProps, "href"> {
    href: WebPageURL | null;
    children: React.ReactNode;
}

export const Link = (props: IProps): React.JSX.Element => {
    const href = props.href ? isoWebPageURL.unwrap(props.href) : undefined;
    return (
        <a {...props} href={href}>
            {props.children}
        </a>
    );
};
